/**
 * The ordinary rotate screen's two lines in every language but English, for
 * the head bundle to write into the card before it is painted
 * (rotate-overlay-copy.js).
 *
 * A COPY OF ui.json, letter for letter: `game.rotateTitle`,
 * `game.rotateBody` and the three rotation-lock lines under it,
 * `game.rotateLockIos`, `game.rotateLockAndroid` and `game.rotateLockOther`. The head can neither wait for the language file (on a
 * real link it lands after the first paint) nor carry ui.json (every word of
 * the game, in eight languages). English is the copy index.html carries.
 * Reword a line in ui.json and reword it here as well:
 * tests/unit/client/rotateOverlayCopy.test.js fails until both say the same.
 */
export const ROTATE_OVERLAY_WORDS = Object.freeze({
  ja: Object.freeze({
    title: '端末を横向きにしてください',
    body: 'Moonfallは大きな画面（デスクトップやノートPC）でこそ真価を発揮します。スマートフォンでも、横向きにすれば月は昇ります。',
    lockIos: '画面が回転しない場合は、コントロールセンターで「画面縦向きのロック」をオフにしてください。',
    lockAndroid: '画面が回転しない場合は、クイック設定で「自動回転」をオンにしてください。',
    lockOther: '画面が回転しない場合は、画面の回転ロックをオフにしてください。',
  }),
  ko: Object.freeze({
    title: '기기를 돌려주세요',
    body: 'Moonfall은 데스크톱이나 노트북 같은 큰 화면에서 가장 빛납니다. 휴대폰에서도 가로로 돌리면 달은 떠오릅니다.',
    lockIos: '화면이 돌아가지 않나요? 제어 센터에서 ‘세로 화면 방향 고정’을 끄세요.',
    lockAndroid: '화면이 돌아가지 않나요? 빠른 설정에서 ‘자동 회전’을 켜세요.',
    lockOther: '화면이 돌아가지 않나요? 화면 회전 잠금을 끄세요.',
  }),
  'zh-CN': Object.freeze({
    title: '请旋转设备',
    body: 'Moonfall 在大屏幕上体验最佳——台式机或笔记本。用手机也行，横过来，月亮照样升起。',
    lockIos: '屏幕不旋转？请在“控制中心”关闭“竖排方向锁定”。',
    lockAndroid: '屏幕不旋转？请在快捷设置中开启“自动旋转”。',
    lockOther: '屏幕不旋转？请关闭屏幕旋转锁定。',
  }),
  de: Object.freeze({
    title: 'Bitte Gerät drehen',
    body: 'Moonfall entfaltet sich am besten auf einem großen Bildschirm — Desktop oder Laptop. Auf dem Handy geht es auch: quer drehen, und der Mond geht trotzdem auf.',
    lockIos: 'Dreht sich nichts? Öffne das Kontrollzentrum und schalte die Ausrichtungssperre aus.',
    lockAndroid: 'Dreht sich nichts? Öffne die Schnelleinstellungen und schalte „Automatisch drehen“ ein.',
    lockOther: 'Dreht sich nichts? Schalte die Drehsperre aus.',
  }),
  fr: Object.freeze({
    title: 'Tournez votre appareil',
    body: 'Moonfall se révèle sur grand écran — ordinateur de bureau ou portable. Sur téléphone aussi : tournez-le à l\'horizontale et la lune se lève quand même.',
    lockIos: 'L’écran ne pivote pas ? Ouvrez le centre de contrôle et désactivez le verrouillage de l’orientation portrait.',
    lockAndroid: 'L’écran ne pivote pas ? Ouvrez les réglages rapides et activez « Rotation automatique ».',
    lockOther: 'L’écran ne pivote pas ? Désactivez le verrouillage de la rotation.',
  }),
  es: Object.freeze({
    title: 'Gira tu dispositivo',
    body: 'Moonfall luce mejor en una pantalla grande — ordenador de sobremesa o portátil. En el móvil también: gíralo en horizontal y la luna saldrá igual.',
    lockIos: '¿La pantalla no gira? Abre el centro de control y desactiva el bloqueo de la orientación vertical.',
    lockAndroid: '¿La pantalla no gira? Abre los ajustes rápidos y activa «Girar automáticamente».',
    lockOther: '¿La pantalla no gira? Desactiva el bloqueo de rotación.',
  }),
  pt: Object.freeze({
    title: 'Gire o seu dispositivo',
    body: 'Moonfall fica melhor num ecrã grande — computador ou portátil. No telemóvel também dá: vire-o na horizontal e a lua nasce na mesma.',
    lockIos: 'A tela não gira? Abra a Central de Controle e desative o Bloqueio de Orientação Vertical.',
    lockAndroid: 'A tela não gira? Abra as configurações rápidas e ative “Girar automaticamente”.',
    lockOther: 'A tela não gira? Desative o bloqueio de rotação.',
  }),
});
